'use strict';

module.exports = function () {
  throw new Error(
    'ws does not work in the browser. Browser clients must use the native ' +
      'WebSocket object'
  );
};



//////////////////
// WEBPACK FOOTER
// ./~/mqtt/~/ws/browser.js
// module id = 260
// module chunks = 73